import styled from '@emotion/styled';
import { Pagination } from 'evergreen-ui';

const CustomPagination = styled(Pagination)`
  button {
    font-size: 16px;

    &:not([disabled])[aria-current='true'] {
      color: #fff;
      background-color: var(--primary-default-color);
    }
  }
`;

export default CustomPagination;
